import React from "react";

class DashboardScreen extends React.Component {
  render() {
    return (
      <div>
        <h1>DashboardScreen</h1>
      </div>
    );
  }
}

export default DashboardScreen;
